import { render, staticRenderFns } from "./commonRadio.vue?vue&type=template&id=294a004a&scoped=true"
import script from "./commonRadio.vue?vue&type=script&lang=js"
export * from "./commonRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a004a",
  null
  
)

export default component.exports